import _ from 'lodash';
import { randomizableGradientColors } from 'scribe-web-shared/consts/gradientColors';

export const randomizableColors = Object.keys(randomizableGradientColors);
export const generateRandomGradientColors = () => _.sampleSize(randomizableColors, 3).join(',');
